<template>
  <Modal
    v-model="visible"
    title="设备分账设置"
    width="700"
    @on-visible-change="visibleChange"
  >
    <div class="tips">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right:10px;" />微信商户号需要开启分账回退功能，步骤如下：商户平台-交易中心-分账-分账接收设置下，开启同意分账回退后，才能正常对异常订单进行退款操作。
    </div>
    <div class="dispense_box">
      <div>
        设备序列号：<span style="font-weight: bold">{{ machine.sn }}</span>
      </div>
      <div style="margin-top: 26px">
        <span>&nbsp;&nbsp;&nbsp;微信商户号：</span>
        <Select
          v-model="machine_dispense.wechat_pay_account_id"
          class="select"
          style="width: 300px"
          placeholder="选择微信收款商户号"
        >
          <Option
            v-for="(item, index) in dispense"
            style="text-align: left"
            :key="index"
            :disabled="item.is_del === -1"
            :value="item.id"
            v-if="item.open_id"
            >ID:{{ item.id }}&nbsp;&nbsp;{{ item.name
            }}{{ item.is_del === -1 ? "(未绑定收款方式)" : "" }}</Option
          >
        </Select>
      </div>

      <div style="margin-top: 26px">
        <span>支付宝商户号：</span>
        <Select
          v-model="machine_dispense.ali_pay_account_id"
          class="select"
          style="width: 300px"
          placeholder="选择支付宝商户号"
        >
          <Option
            v-for="(item, index) in dispense"
            style="text-align: left"
            :key="index"
            :disabled="item.is_del === -1"
            :value="item.id"
            v-if="item.user_id"
            >ID:{{ item.id }}&nbsp;&nbsp;{{ item.name
            }}{{ item.is_del === -1 ? "(未绑定收款方式)" : "" }}</Option
          >
        </Select>
      </div>
    </div>
    <div slot="footer">
      <Button @click="visibleChange(false)">取消</Button>
      <Button v-preventReClick type="primary" @click="save">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
    machine: {
      default: () => {
        return {
          id: 0,
          sn: ""
        };
      }
    }
  },
  data() {
    return {
      visible: this.value,
      dispense: [],
      machine_dispense: {
        machine_id: this.machine.id,
        wechat_pay_account_id: 0,
        ali_pay_account_id: 0,
        id: 0
      }
    };
  },
  mounted() {},
  methods: {
    ...mapActions([
      "GetMachineDispense",
      "GetAgentDispenseAccount",
      "SaveMachineDispense"
    ]),
    visibleChange(e = false) {
      if (!e) {
        this.$emit("cancel", false);
        return false;
      }
    },
    getMachineDispense() {
      this.GetMachineDispense({ machine_id: this.machine.id }).then(res => {
        let data = res.data;
        if (Object.keys(data).length) {
          this.machine_dispense = data;
        }
      });
    },
    getAgentDispenseAccount() {
      this.GetAgentDispenseAccount({ agent_id: this.machine.agent_id }).then(
        res => {
          this.dispense = res.data;
        }
      );
    },
    save() {
      const data = { ...this.machine_dispense };
      if (!data.machine_id) {
        this.$Message.error("系统异常");
        return false;
      }
      if (!data.wechat_pay_account_id) {
        this.$Message.error("请选择微信商户号");
        return false;
      }
      if (!data.ali_pay_account_id) {
        this.$Message.error("请选择支付宝商户号");
        return false;
      }
      this.SaveMachineDispense(data).then(res => {
        if (!res.status) {
          this.$Message.error(res.msg);
          return false;
        }
        this.visibleChange(false);
      });
    }
  },
  computed: mapGetters({
    agent: "agent"
  }),
  watch: {
    value() {
      this.visible = this.value;
    },
    machine() {
      this.machine_dispense = {
        machine_id: this.machine.id,
        wechat_pay_account_id: 0,
        ali_pay_account_id: 0,
        id: 0
      };
      this.getAgentDispenseAccount();
      this.getMachineDispense();
    }
  }
};
</script>
<style lang="less">
@import "./index.less";
</style>
